import { render, staticRenderFns } from "./BaseModalEx.vue?vue&type=template&id=439e4b90&scoped=true"
import script from "./BaseModalEx.vue?vue&type=script&lang=js"
export * from "./BaseModalEx.vue?vue&type=script&lang=js"
import style0 from "./BaseModalEx.vue?vue&type=style&index=0&id=439e4b90&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439e4b90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('439e4b90')) {
      api.createRecord('439e4b90', component.options)
    } else {
      api.reload('439e4b90', component.options)
    }
    module.hot.accept("./BaseModalEx.vue?vue&type=template&id=439e4b90&scoped=true", function () {
      api.rerender('439e4b90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaModal/BaseModalEx.vue"
export default component.exports